export default __webpack_public_path__ + "clientapp/media/robot-04.21a465fb.png";